/** @format */

import {Trans} from 'react-i18next';

import {CtaInner, CtaLabel, CtaRoot, SetupButton} from './styles';

interface Props {
  onSetup: () => void;
  // summary no-mediaplan: CTA sits inside the narrow Расход box → fill its width.
  fullWidth?: boolean;
}

/**
 * "No mediaplan" placeholder rendered in the KPI section when the project has
 * no mediaplan configured.
 *
 * Layouts per Figma:
 *  - dynamic (10284:125368): left half of the metrics row; flex: 1 0 0 applied
 *    by the parent MetricsBlock so the CTA grows to fill available space.
 *  - summary (10286:128514): bottom row spanning the full KPI table width;
 *    parent MetricsBlock mounts it below the grid.
 *
 * Both modes share the same cross-hatch background and inner content — text +
 * primary button. The only structural difference is that in dynamic mode the
 * parent controls flex-grow; here we simply fill 100% of the available height.
 */
function MediaplanCta({onSetup, fullWidth = false}: Props) {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onSetup();
  };

  return (
    <CtaRoot fullWidth={fullWidth}>
      <CtaInner fullWidth={fullWidth}>
        <CtaLabel>
          <Trans>В проекте не настроен медиаплан</Trans>
        </CtaLabel>

        <SetupButton data-testid='setup-mediaplan' onClick={handleClick} disableRipple={false}>
          <Trans>Настроить медиаплан</Trans>
        </SetupButton>
      </CtaInner>
    </CtaRoot>
  );
}

export {MediaplanCta};
